/**
 * Demographics Process Handlers
 *
 * Handles saving and deleting individual demographic answers in Firestore.
 * Collection: userDemographics/{userId}/answers/{questionId}
 */

import { handleRequest } from './config'
import * as handlers from '../handlers'
import { DemographicAnswers } from '../../../../pure-js/types/Demographics'

export const saveDemographicAnswer = async (params: {
  userId: string
  questionId: string
  answer: number
  otherText?: string | null
}) => {
  return handleRequest(
    async () => ({ data: undefined, success: true }),
    async () =>
      handlers.directDb.saveDemographicAnswer(params.userId, params.questionId, params.answer, params.otherText)
  )
}

export const deleteDemographicAnswer = async (params: { userId: string; questionId: string }) => {
  return handleRequest(
    async () => ({ data: undefined, success: true }),
    async () => handlers.directDb.deleteDemographicAnswer(params.userId, params.questionId)
  )
}

export const getDemographicAnswersCount = async (params: { userId: string }) => {
  return handleRequest(
    async () => ({ data: 0, success: true }),
    async () => handlers.directDb.getDemographicAnswersCount(params.userId)
  )
}

export const getDemographicAnswers = async (params: { userId: string }) => {
  return handleRequest(
    async () => ({ data: {} as DemographicAnswers, success: true }),
    async () => handlers.directDb.getDemographicAnswers(params.userId)
  )
}
